function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M57 13H41a4 4 0 00-4-4h-2.59l6.3-6.29-1.42-1.42L32 8.59l-7.29-7.3-1.42 1.42L29.59 9H27a4 4 0 00-4 4H7a6 6 0 00-6 6v30a6 6 0 005.2 5.94l1.8 7.3A1 1 0 009 63h4a1 1 0 001-.76L15.78 55h32.44L50 62.24a1 1 0 001 .76h4a1 1 0 001-.76l1.83-7.3A6 6 0 0063 49V19a6 6 0 00-6-6zm-30-2h10a2 2 0 012 2H25a2 2 0 012-2zM12.22 61H9.78l-1.5-6h5.44zm42 0h-2.44l-1.5-6h5.44zM61 49a4 4 0 01-4 4H7a4 4 0 01-4-4V19a4 4 0 014-4h50a4 4 0 014 4z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M47 17H7a2 2 0 00-2 2v30a2 2 0 002 2h40a2 2 0 002-2V19a2 2 0 00-2-2zM7 49V19h40v30zM55 17a4 4 0 104 4 4 4 0 00-4-4zm2 4a2.09 2.09 0 01-.07.51l-2.44-2.44A2.09 2.09 0 0155 19a2 2 0 012 2zm-4 0a2.09 2.09 0 01.07-.51l2.44 2.44A2.09 2.09 0 0155 23a2 2 0 01-2-2zM55 27a4 4 0 104 4 4 4 0 00-4-4zm0 2a2.09 2.09 0 01.51.07l-2.44 2.44A2.09 2.09 0 0153 31a2 2 0 012-2zm0 4a2.09 2.09 0 01-.51-.07l2.44-2.44A2.09 2.09 0 0157 31a2 2 0 01-2 2zM58 37h-6a1 1 0 00-1 1v4a1 1 0 001 1h6a1 1 0 001-1v-4a1 1 0 00-1-1zm-1 4h-4v-2h4zM58 45h-6a1 1 0 00-1 1v4a1 1 0 001 1h6a1 1 0 001-1v-4a1 1 0 00-1-1zm-1 4h-4v-2h4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.29 40.291l14-13.998 1.413 1.414-13.998 13.998zM19.29 40.291l14-13.998 1.413 1.414-13.998 13.998zM29.29 40.291l14-13.998 1.413 1.414-13.998 13.998z"
});

var SvgTv = function SvgTv(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    "data-name": "Layer 3",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TV.3b03b483.svg";
export { ForwardRef as ReactComponent };